import { type SelectOption } from '../../../../../components';
import { PAGE_TEXT } from '../../lang';
import { FundingPanel, ProjectRole } from './types';

const panelText = PAGE_TEXT.FUNDING_SOURCE.PANEL.VALUES;

export const panelOptions: SelectOption[] = [
  {
    value: FundingPanel.HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES,
    label: panelText.HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES,
  },

  {
    value: FundingPanel.SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY,
    label: panelText.SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY,
  },
];
export const panelOptionWithMixed: SelectOption[] = [
  {
    value: FundingPanel.HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES,
    label: panelText.HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES,
  },

  {
    value: FundingPanel.SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY,
    label: panelText.SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY,
  },
  {
    value: FundingPanel.MIXED,
    label: panelText.MIXED,
  },
];

export const panelOptionWithMixedAbbv: SelectOption[] = [
  {
    value: FundingPanel.HUMANITIES_SOCIAL_SCIENCES_BUSINESS_STUDIES,
    label: 'H',
  },

  {
    value: FundingPanel.SCIENCES_MEDICINE_ENGINEERING_TECHNOLOGY,
    label: 'S',
  },
  {
    value: FundingPanel.MIXED,
    label: panelText.MIXED,
  },
];

// TODO
// When the backend is ready,
// request the Round list from the backend instead.
export const roundOptions: SelectOption[] = [
  { label: 'Nov 2023', value: 'Nov 2023' },
  { label: 'Sep 2023', value: 'Sep 2023' },
  { label: 'Mar 2023', value: 'Mar 2023' },
  { label: 'HKPFS & Jan 2023', value: 'HKPFS & Jan 2023' },
  { label: 'Nov 2022', value: 'Nov 2022' },
  { label: 'Sep 2022', value: 'Sep 2022' },
  { label: 'May 2022', value: 'May 2022' },
];

export const roleOptions: SelectOption[] = [
  {
    label: PAGE_TEXT.FUNDING_SOURCE.ROLE.PI.LABEL,
    value: ProjectRole.PI,
  },
  {
    label: PAGE_TEXT.FUNDING_SOURCE.ROLE.CI.LABEL,
    value: ProjectRole.CI,
  },
];
